import React, { useState } from 'react';
//import { TabNavigation, Tab } from 'evergreen-ui'
//import styles from 'react-bootstrap';

const TabNav = (props: any) => {

    return (
        <div >
            <ul className="nav nav-tabs" style={{ padding: '0px 20px' }}>
                {
                    props.tabs.map((t: string) => {
                        const active = (t === props.selected ? 'active ' : '');
                        return (
                            <li className="nav-item" key={t}>
                                <a className={"nav-link " + active} onClick={() => props.setSelected(t)}>
                                    {t}
                                </a>
                            </li>
                        );
                    })
                }
            </ul>
            {props.children}
        </div>
    );
}

export default TabNav 